export const OPEN_ALERT = "OPEN_ALERT";

export const CLOSE_ALERT = "CLOSE_ALERT";
